<ul class="side-nav">
  @for (item of items(); track item.id) {
    @if (item.visible) {
      @if (hasChildren(item)) {
        <li class="side-nav-item"
            [class.is-active]="isActive(item)"
            [class.is-parent-active]="isParentActive(item)"
            [class.open]="!item.collapsed">
          <button
            type="button"
            class="side-nav-link"
            [pTooltip]="item.label" tooltipPosition="right" [tooltipDisabled]="!sidebarService.isCondensed()"
            [attr.aria-expanded]="!item.collapsed"
            (click)="toggleTopLevelItem(item)"
          >
            @if (item.icon) { <i class="menu-icon" [class]="item.icon"></i> }
            <span class="menu-text">{{ item.label }}</span>
            <span class="menu-arrow"><i class="pi pi-chevron-down"></i></span>
          </button>

          <div class="collapse-wrapper" [class.expanded]="!item.collapsed">
            <ul class="sub-menu">
              @for (child of item.children; track child.id) {
                @if (child.visible) {
                  @if (hasChildren(child)) {
                    <li class="side-nav-item nav-depth-1"
                        [class.is-active]="isActive(child)"
                        [class.is-parent-active]="isParentActive(child)"
                        [class.open]="!child.collapsed">
                      <button type="button" class="side-nav-link"
                              [attr.aria-expanded]="!child.collapsed"
                              (click)="toggleItem(child)">
                        <span class="menu-arrow menu-arrow-leading"><i class="pi pi-chevron-right"></i></span>
                        @if (child.icon) { <i class="menu-icon" [class]="child.icon"></i> }
                        <span class="menu-text">{{ child.label }}</span>
                      </button>
                      <div class="collapse-wrapper" [class.expanded]="!child.collapsed">
                        <ul class="sub-menu">
                          @for (grandchild of child.children; track grandchild.id) {
                            @if (grandchild.visible) {
                              <li class="side-nav-item nav-depth-2"
                                  [class.is-active]="isActive(grandchild)">
                                @if (grandchild.route) {
                                  <a class="side-nav-link" (click)="navigateTo(grandchild.route)">
                                    @if (grandchild.icon) { <i class="menu-icon" [class]="grandchild.icon"></i> }
                                    <span class="menu-text">{{ grandchild.label }}</span>
                                  </a>
                                } @else if (grandchild.href) {
                                  <a class="side-nav-link" [href]="grandchild.href">
                                    @if (grandchild.icon) { <i class="menu-icon" [class]="grandchild.icon"></i> }
                                    <span class="menu-text">{{ grandchild.label }}</span>
                                  </a>
                                }
                              </li>
                            }
                          }
                        </ul>
                      </div>
                    </li>
                  } @else {
                    <li class="side-nav-item nav-depth-1"
                        [class.is-active]="isActive(child)">
                      @if (child.route) {
                        <a class="side-nav-link" (click)="navigateTo(child.route)">
                          @if (child.icon) { <i class="menu-icon" [class]="child.icon"></i> }
                          <span class="menu-text">{{ child.label }}</span>
                        </a>
                      } @else if (child.href) {
                        <a class="side-nav-link" [href]="child.href">
                          @if (child.icon) { <i class="menu-icon" [class]="child.icon"></i> }
                          <span class="menu-text">{{ child.label }}</span>
                        </a>
                      }
                    </li>
                  }
                }
              }
            </ul>
          </div>
        </li>
      } @else {
        <li class="side-nav-item" [class.is-active]="isActive(item)">
          @if (item.route) {
            <a class="side-nav-link"
               [pTooltip]="item.label" tooltipPosition="right" [tooltipDisabled]="!sidebarService.isCondensed()"
               (click)="navigateTo(item.route)">
              @if (item.icon) { <i class="menu-icon" [class]="item.icon"></i> }
              <span class="menu-text">{{ item.label }}</span>
            </a>
          } @else if (item.href) {
            <a class="side-nav-link" [href]="item.href"
               [pTooltip]="item.label" tooltipPosition="right" [tooltipDisabled]="!sidebarService.isCondensed()">
              @if (item.icon) { <i class="menu-icon" [class]="item.icon"></i> }
              <span class="menu-text">{{ item.label }}</span>
            </a>
          }
        </li>
      }
    }
  }
</ul>
